(() => {
  if (customElements.get('maxler-category-grid')) return;

  class MaxlerCategoryGrid extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.expanded ??= false;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.viewport = matchMedia('(min-width: 750px)');
      this.viewport.addEventListener('change', () => this.refresh(), {signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-category-toggle]');
        if (!button || button !== this.button || button.hidden || button.disabled) return;
        event.preventDefault();
        this.expanded = !this.expanded;
        this.refresh();
        if (!this.expanded) {
          button.focus({preventScroll: true});
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (!this.isConnected || button.hidden) return;
            const bounds = button.getBoundingClientRect();
            const topElement = document.elementFromPoint(bounds.left + bounds.width / 2, Math.max(0, Math.min(innerHeight - 1, bounds.top + bounds.height / 2)));
            if (bounds.top < 0 || bounds.bottom > innerHeight || !button.contains(topElement)) button.scrollIntoView({block: 'center', inline: 'nearest', behavior: 'instant'});
          });
        }
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const selected = this.cards?.find(card => String(card.dataset.blockId) === String(event.detail?.blockId));
        if (selected?.hidden) {
          this.expanded = true;
          this.refresh();
        }
      }, {signal});
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this, {childList: true, subtree: true});
      this.refresh();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
      cancelAnimationFrame(this.scrollFrame);
      this.cards?.forEach(card => card.hidden = false);
      if (this.button) {
        this.button.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
      }
      delete this.dataset.categoryInitialized;
    }

    refresh() {
      const list = this.querySelector('[data-category-list]');
      const button = this.querySelector('[data-category-toggle]');
      if (!list) return;
      this.list = list;
      this.button = button;
      this.cards = [...list.children].filter(card => card.matches('[data-category-card]'));
      const count = this.cards.length;
      const visibleCount = this.viewport.matches ? 3 : 2;
      const canExpand = count > visibleCount && !!button;
      if (count <= 2) this.expanded = false;
      const expanded = canExpand && this.expanded;
      const activeElement = document.activeElement;
      const focusWillHide = !expanded && this.cards.slice(visibleCount).some(card => card.contains(activeElement));
      if (focusWillHide && canExpand) button.focus({preventScroll: true});
      this.cards.forEach((card, index) => card.hidden = canExpand && !expanded && index >= visibleCount);
      if (button) {
        button.hidden = !canExpand;
        button.setAttribute('aria-expanded', String(expanded));
        if (list.id) button.setAttribute('aria-controls', list.id);
        const label = expanded ? this.dataset.lessLabel : (this.dataset.moreLabel || '').split('__CATEGORY_COUNT__').join(String(count));
        if (button.textContent !== label) button.textContent = label;
      }
      this.dataset.categoryInitialized = 'true';
    }
  }

  customElements.define('maxler-category-grid', MaxlerCategoryGrid);
})();
